<template>
  <div class="login-page">
    <div class="login-box">
      <div class="login-logo">
        <img src="~@/assets/logo-long.png" alt="">
      </div>
      <!-- /.login-logo -->
      <div class="card">

        <div class="card-body login-card-body">

          <b-alert v-if="error" variant="danger" show fade>{{ $t(error.toString()) }}</b-alert>

          <b-form @submit.stop.prevent="login">
            <b-form-group id="example-input-group-1" label-for="example-input-1">
              <div class="input-group mb-3">
                <b-form-input
                    id="example-input-1"
                    name="example-input-1"
                    placeholder="Email"
                    v-model="$v.form.email.$model"
                    ref="email"
                    :state="validateState('email')"
                    aria-describedby="input-1-live-feedback"
                ></b-form-input>

                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                  </div>
                </div>
                <b-form-invalid-feedback
                    id="input-1-live-feedback"
                >This is a required field and must be email.
                </b-form-invalid-feedback>
              </div>

            </b-form-group>

            <b-form-group id="example-input-group-2" label-for="example-input-2">
              <div class="input-group mb-3">
                <b-form-input
                    placeholder="Password"
                    id="example-input-2"
                    name="example-input-2"
                    type="password"
                    v-model="$v.form.password.$model"
                    :state="validateState('password')"
                    aria-describedby="input-2-live-feedback"
                ></b-form-input>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-lock"></span>
                  </div>
                </div>
                <b-form-invalid-feedback
                    id="input-2-live-feedback"
                >This is a required field.
                </b-form-invalid-feedback>
              </div>


            </b-form-group>
            <div class="d-flex flex-row justify-content-end w-100">
              <b-button variant="primary" type="submit" :disabled="loading">
                <div v-if="loading">
                  <b-spinner small type="grow"></b-spinner>
                  {{$t('state.loading')}}
                </div>
                <div v-else>
                  Login
                </div>
              </b-button>
            </div><!-- /.col -->
          </b-form>
        </div>
        <!-- /.login-card-body -->
      </div>
    </div>
  </div>

</template>

<script>
import {validationMixin} from "vuelidate";
import {required, email} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  data() {
    return {
      configuration: false,
      games: false,
      email: null,
      error: null,
      password: null,
      form: {
        email: null,
        password: null
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  computed: {
    loading: function () {
      return this.$store.getters["root/loading"];
    },
  },
  mounted() {
    this.$refs.email.focus();
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    login() {
      this.error = null;
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return;
      }


      this.$store.dispatch('root/login', {email: this.form.email, password: this.form.password}).then(
          () => {
            this.$router.push({name: 'dashboard'});
          },
          error => {
            this.error = 'login.error.' + error.response.status;
            this.$store.commit('root/setLoader', false);
          }
      )

    }
  }
}
</script>
